export const MINI_DETAIL_SIZE = {
  BASE: 320,
} as const;

export const HEIGHT = {
  VIDEO_PLAYER: 180,
  DESCRIPTION: 140,
  SHADOW: 104,
} as const;
